import React from 'react';
import icons from './icons';

const Icon = (props: any) => {
  const icon = icons[props.name] || icons['unknown'];

  const svgParams = {
    ...icon,
    paths: undefined
  };

  return (
    <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 16 16" {...svgParams} {...props}>
      {icon.paths && icon.paths.map((path: Object, key: number) => <path key={key} fillRule="evenodd" {...path} />)}
    </svg>
  );
};

export default Icon;
